import { render, staticRenderFns } from "./EditQuestionnaire.vue?vue&type=template&id=52a512fc&scoped=true&"
import script from "./EditQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./EditQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestionnaire.vue?vue&type=style&index=0&id=52a512fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a512fc",
  null
  
)

export default component.exports